export default __webpack_public_path__ + "static/Sarah-7590f40da7f262616236387a3cff8830.webp";